import React from "react";
import PropTypes from 'prop-types';
import {UIColors} from "../config/UIConfig";
import {Grid} from "@material-ui/core";
import "../styles/general.scss";
import LoadingPageBG from "../images/loading/loading_page_bg.png";
import Title from "../images/loading/title.png";
import MainTitle from "../images/loading/main_title.png";

class LoadingPage extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            progress: 0,
            prepared: false
        };

        this.titleDownloaded = false;
        this.mainTitleDownloaded = false;
        this.backgroundDownloaded = false;

        this.checkLoaded = this
            .checkLoaded
            .bind(this);
    }

    formatValue = (value) => value.toFixed(0);

    componentDidMount()
    {
        this.setState({progress: this.props.progress});
    }

    checkLoaded(mode)
    {
        switch (mode) {
            default:
                break;
            case 0:
                this.titleDownloaded = true;
                break;
            case 1:
                this.mainTitleDownloaded = true;
                break;
            case 2:
                this.backgroundDownloaded = true;
                break;
        }
        if (this.titleDownloaded && this.mainTitleDownloaded && this.backgroundDownloaded) {
            this.setState({prepared: true});
            console.log("Starting to download images");
            this
                .props
                .fullyLoadedFunc();
        }
    }

    render()
    {
        return (
            <div
                style={{
                backgroundColor: UIColors.backgroundDefault,
                width: "100vw",
                height: "100vh"
            }}>
                <div
                    className={this.state.prepared
                    ? "fade-in"
                    : ""}
                    style={{
                    height: "100vh",
                    width: "100vw",
                    animationDuration: "1s",
                    WebkitAnimationDuration: "1s",
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <img
                        onLoad={() => this.checkLoaded(2)}
                        src={LoadingPageBG}
                        alt={"Background"}
                        style={{
                        zIndex: 0,
                        objectFit: "cover",
                        position: "absolute",
                        minHeight: "100vh",
                        maxWidth: "100vw",
                        overflow: "hidden",
                        justifySelf: "center",
                        alignSelf: "center"
                    }}/>
                    <img
                        onLoad={() => this.checkLoaded(1)}
                        src={MainTitle}
                        alt={"Background"}
                        style={{
                        zIndex: 2,
                        objectFit: "cover",
                        position: "absolute",
                        maxHeight: "100vh",
                        maxWidth: "90%",
                        overflow: "hidden",
                        justifySelf: "center",
                        alignSelf: "center"
                    }}/>
                    <div
                        style={{
                        zIndex: 5,
                        height: "100vh",
                        width: "100vw",
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center"
                    }}>
                        <Grid
                            className="loading-progress"
                            item
                            container
                            direction="row"
                            style={{
                            alignSelf: "center",
                            width: "100vw",
                            marginTop: "30vh",
                            justifyContent: "center"
                        }}>
                            <Grid
                                item
                                style={{
                                alignSelf: "flex-end",
                                color: "#1c2f76",
                                fontFamily: "ArialRoundedBold",
                                fontSize: "5vh"
                            }}>
                                LOADING
                            </Grid>
                            <Grid
                                className="larger-font"
                                item
                                style={{
                                alignSelf: "flex-end",
                                color: "#1c2f76",
                                fontFamily: "ArialRoundedBold",
                                fontSize: "6.5vh"
                            }}>&nbsp;&nbsp;{(100 / this.props.total * (Math.min(this.props.loaded, this.props.total))).toFixed(0)}&nbsp;%</Grid>
                        </Grid>
                    </div>
                    <img
                        onLoad={() => this.checkLoaded(0)}
                        src={Title}
                        alt={"Title"}
                        style={{
                        zIndex: 10,
                        position: "absolute",
                        right: "7.5vw",
                        top: 0,
                        maxHeight: "15vh",
                        maxWidth: "30vw"
                    }}/>
                </div>
            </div>
        );
    }
}

LoadingPage.propTypes = {
    loaded: PropTypes.number,
    total: PropTypes.number,
    fullyLoadedFunc: PropTypes.func
};

LoadingPage.defaultProps = {
    loaded: 0,
    total: 0,
    fullyLoadedFunc: function () {
        console.log("fullyLoadedFunc");
    }
};

export default LoadingPage;